import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { SvgIconComponent } from '@dmb/core';

import { SessionLabelOption } from '../../../model';
import { ClientService, SessionService } from '../../../services';
import { ModalService } from '../modal.service';
import { SelectClientComponent } from './select-client/select-client.component';
import { SelectLabelComponent } from './select-label/select-label.component';

@Component({
  selector: 'dmb-switch-client',
  templateUrl: './switch-client.component.html',
  styleUrl: './switch-client.component.scss',
  imports: [AsyncPipe, SvgIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchClientComponent {
  private modalService = inject(ModalService);
  private clientService = inject(ClientService);
  sessionService = inject(SessionService);

  clientSelectable = computed(() => {
    const list = this.clientService.clientList();
    return list !== undefined && list.length > 0;
  });

  selectLabel(lbl: SessionLabelOption) {
    if (lbl.selectable) {
      this.modalService.openDialog(SelectLabelComponent, undefined, { maxWidth: '100vw' });
    }
  }

  selectClient() {
    if (this.clientSelectable()) {
      this.modalService.openDialog(SelectClientComponent, undefined, { maxWidth: '100vw' });
    }
  }
}
